import { render, staticRenderFns } from "./miniprogramCard.vue?vue&type=template&id=b143e550&scoped=true"
import script from "./miniprogramCard.vue?vue&type=script&lang=js"
export * from "./miniprogramCard.vue?vue&type=script&lang=js"
import style0 from "./miniprogramCard.vue?vue&type=style&index=0&id=b143e550&prod&scoped=true&lang=css"
import style1 from "./miniprogramCard.vue?vue&type=style&index=1&id=b143e550&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b143e550",
  null
  
)

export default component.exports